import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { PrerenderData, readPrerenderData } from './prerender/data';
import { AuthProvider } from './context/AuthContext'; // adjust path if needed

const container = document.getElementById('root');
const data = readPrerenderData();
const app = <React.StrictMode>
  <BrowserRouter>
    <PrerenderData.Provider value={data}>
      <AuthProvider><App /></AuthProvider>
    </PrerenderData.Provider>
  </BrowserRouter>
</React.StrictMode>;
const path = window.location.pathname.replace(/\/+$/, '') || '/';
const canHydrate = container.dataset.prerendered === 'true' && data?.pathname === path &&
  !window.location.search && !window.location.hostname.startsWith('admin.');
if (canHydrate) ReactDOM.hydrateRoot(container, app);
else ReactDOM.createRoot(container).render(app);
